import { render, staticRenderFns } from "./parameterDialog.vue?vue&type=template&id=4a4b8e16&scoped=true"
import script from "./parameterDialog.vue?vue&type=script&lang=js"
export * from "./parameterDialog.vue?vue&type=script&lang=js"
import style0 from "./parameterDialog.vue?vue&type=style&index=0&id=4a4b8e16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4b8e16",
  null
  
)

export default component.exports